// Inline zoom — instant on first click.
// Strategy: show the overlay immediately using the image variant the browser has
// already rendered (zero network), then seamlessly upgrade to the full-size image
// once it finishes loading in the background. Full-size images are also prefetched
// on hover so they are usually cached before the user ever clicks.
let overlay;
const hiResCache = {};

function preloadHiRes(image) {
  const src = image.src;
  let cached = hiResCache[src];
  if (!cached) {
    cached = new Image();
    cached.src = src;
    hiResCache[src] = cached;
  }
  return cached;
}

function createOverlay(image) {
  overlay = document.createElement('div');
  overlay.setAttribute('class', 'image-zoom-inline-full-size');
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.backgroundColor = 'var(--color-background)';

  // Instant: reuse the already-rendered variant (no download needed).
  const instantSrc = image.currentSrc || image.src;
  overlay.style.backgroundImage = `url('${instantSrc}')`;
  image.parentElement.insertBefore(overlay, image);

  // Background upgrade to the full-size image for maximum sharpness.
  const hiRes = preloadHiRes(image);
  if (hiRes.src !== instantSrc) {
    const upgrade = () => {
      if (overlay) overlay.style.backgroundImage = `url('${hiRes.src}')`;
    };
    if (hiRes.complete && hiRes.naturalWidth > 0) {
      upgrade();
    } else {
      hiRes.addEventListener('load', upgrade, { once: true });
    }
  }

  return overlay;
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlayEl = createOverlay(image);
  overlayEl.onclick = () => overlayEl.remove();
  overlayEl.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlayEl.onmouseleave = () => overlayEl.remove();
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-zoom-inline');
  images.forEach((image) => {
    // Warm the cache as soon as the cursor reaches the photo.
    image.addEventListener('pointerenter', () => preloadHiRes(image));
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
